export const SamplingFrequencys = [
    { name: { zh: '不抽样', en: 'None' }, value: 'None' },
    { name: { zh: '每分钟', en: 'EveryMinute' }, value: 'EveryMinute' },
    { name: { zh: '每5分钟', en: 'EveryFiveMinute' }, value: 'EveryFiveMinute' },
    { name: { zh: '每15分钟', en: 'EveryFifteenMinute' }, value: 'EveryFifteenMinute' },
    { name: { zh: '每半小时', en: 'EveryHalfHour' }, value: 'EveryHalfHour' },
    { name: { zh: '每小时', en: 'EveryHour' }, value: 'EveryHour' },
    { name: { zh: '每4小时', en: 'EveryFourHour' }, value: 'EveryFourHour' },
    { name: { zh: '每8小时', en: 'EveryEightHour' }, value: 'EveryEightHour' },
    { name: { zh: '每12小时', en: 'EveryTwelveHour' }, value: 'EveryTwelveHour' },
    { name: { zh: '每天', en: 'EveryDay' }, value: 'EveryDay' },
    { name: { zh: '每7天', en: 'EverySevenDay' }, value: 'EverySevenDay' },
    { name: { zh: '每月', en: 'EveryMonth' }, value: 'EveryMonth' },
];

export const FrequencyEnums = [
    { name: { zh: '巡检频率>1周', en: 'AboveOneWeek' }, value: 'AboveOneWeek' },
    { name: { zh: '1天<巡检频率<=1周', en: 'AboveOneDay' }, value: 'AboveOneDay' },
    { name: { zh: '4小时<巡检频率<=1天', en: 'AboveFourHour' }, value: 'AboveFourHour' },
    { name: { zh: '1小时<巡检频率<=4小时', en: 'AboveOneHour' }, value: 'AboveOnwHour' },
    { name: { zh: '巡检频率<=1小时', en: 'UnderOneHow' }, value: 'UnderOneHow' },
];